const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

export const validateUrl = (url: string): boolean => {
  return urlRegex.test(url);
};
